import { z } from "zod";

export const lastSoftwareUpdateDtoSchema = z.object({
  dateEnd: z.coerce.date(),
  datePrepared: z.coerce.date(),
  dateSent: z.coerce.date(),
  label: z.string(),
  momboxHwId: z.number(),
  success: z.boolean(),
});

export type TLastSoftwareUpdateDto = z.infer<typeof lastSoftwareUpdateDtoSchema>;
